import gql from 'graphql-tag';

export const ContentAnalyticsViewedComments = gql`
	query ContentAnalyticsViewedComments($contentId: ID!) {
		contentAnalyticsViewedComments(contentId: $contentId) {
			commentIds
		}
	}
`;
